import { menuItemsDef, profileNavItemsDef, settingsItemsDef } from "../navigation/navDefinitions";
import { mapPopupEquipeToAppPath } from "./teamNavigation";
import { resolveNavItemLabel } from "./workspaceSegmentLabels";

const ALL_NAV = [...menuItemsDef, ...profileNavItemsDef, ...settingsItemsDef]
  .filter((x) => x.link)
  .sort((a, b) => b.link.length - a.link.length);

function navLabel(tNav, key, fallback) {
  const tr = tNav?.(key);
  return tr && tr !== key ? tr : fallback;
}

function teamModuleTitle(path, tNav) {
  const mapped = mapPopupEquipeToAppPath(path) || path;
  const clean = String(mapped || "").split("?")[0] || "";

  if (
    clean === "/equipe/escritorio-virtual" ||
    clean.startsWith("/equipe/escritorio-virtual/") ||
    path === "/popup-equipe/escritorio-virtual" ||
    path.startsWith("/popup-equipe/escritorio-virtual/")
  ) {
    return navLabel(tNav, "nav.virtualOffice", "Escritório Virtual");
  }
  if (clean.includes("/tarefas")) return "Tarefas";
  if (clean.includes("/agenda")) return "Agenda";
  if (clean.includes("/atendimento") || clean === "/chat" || clean.startsWith("/chat/")) {
    return navLabel(tNav, "nav.chat", "Atendimento");
  }
  if (clean.includes("/sales-pipeline")) {
    return navLabel(tNav, "nav.salesPipeline", "Pipeline de Vendas");
  }
  if (
    clean === "/pipeline" ||
    clean.startsWith("/pipeline/") ||
    clean === "/equipe/pipeline" ||
    clean.startsWith("/equipe/pipeline/")
  ) {
    return navLabel(tNav, "nav.awareness", "Níveis de consciência");
  }
  if (clean === "/equipe" || /^\/equipe\/[^/]+/.test(clean) || path === "/popup-equipe" || /^\/popup-equipe\/[^/]+/.test(path)) {
    return navLabel(tNav, "nav.team", "Equipe");
  }
  return null;
}

/**
 * Título amigável para a rota atual na telemetria de presença.
 * @param {string} fullPath pathname + opcional ?query
 * @param {(key: string) => string} tNav — ex.: useTranslation("app").t
 * @param {string} [segment] segmento do workspace; quando informado, ajusta rótulos (ex.: Trechos)
 */
export function getTeamPresenceScreenTitle(fullPath, tNav, segment) {
  const path = String(fullPath || "").split("?")[0] || "";
  if (!path) return "—";

  const teamTitle = teamModuleTitle(path, tNav);
  if (teamTitle) return teamTitle;

  if (path.startsWith("/video/") || path === "/video" || path.startsWith("/popup-call/")) {
    return "Chamada de vídeo";
  }

  for (const item of ALL_NAV) {
    const link = item.link;
    if (path === link || path.startsWith(`${link}/`)) {
      if (segment != null) {
        const label = resolveNavItemLabel(item, segment, tNav);
        if (label) return label;
      }
      if (item.textKey) {
        const tr = tNav(item.textKey);
        if (tr && tr !== item.textKey) return tr;
      }
      if (item.label) return item.label;
      if (item.textKey) return tNav(item.textKey);
    }
  }
  return path;
}
